import { appAxios } from "@/lib/config/apiInterceptor";

export const fetchRandomVideos = async () => {
  try {
    const response = await appAxios.get(`/video/get-random`);
    return response.data;
  } catch (error) {
    console.error("Error fetching random videos ", error);
    return { 
      success: false, 
      message: "Data not found at this moment.", 
      data: []
    };
  }
};
export const fetchVideos = async (page: number = 1) => {
  try {
    const response = await appAxios.get(`/video/get?page=${page}`);
    return response.data.videos;
  } catch (error) {
    console.error("Error fetching paginated chats: ", error);
    return {success: false};
  }
};
